import "./privacy.scss";
import data from "./privacy.json";

export default function Privacy() {
  const privacy = data.data;

  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <p className="privacy-title">Privacy Statement</p>
      </div>
      <section className="text-container-section col-xs-12 col-sm-12 col-md-12 col-lg-10">
        <div className="img-content">
          <div className="second-content">
            <p className="para-content">{privacy.p1}</p>
            <p className="para-content">{privacy.p2}</p>
            <p className="para-content">{privacy.h2}</p>
            <p className="para-content">{privacy.p3}</p>
            <p className="para-content">{privacy.h3}</p>
            <p className="para-content">{privacy.p4}</p>
            <p className="para-content">{privacy.h4}</p>
            <p className="para-content">{privacy.p5}</p>
            <p className="para-content">{privacy.h5}</p>
            <p className="para-content">{privacy.p51}</p>
            <p className="para-content">{privacy.p6}</p>
            <p className="para-content">{privacy.h6}</p>
            <p className="para-content">{privacy.p7}</p>
            <p className="para-content">{privacy.p71}</p>
            <p className="address-content">{privacy.h7}</p>
            <p className="address-content">{privacy.h8}</p>
            <p className="address-content">{privacy.h9}</p>
            <p className="address-content">{privacy.h10}</p>
            <p className="address-content">{privacy.h11}</p>
            <p className="address-content">
              {privacy.h12}:{" "}
              <a href="mailto:data.protection@mercedes-benz.com">
                data.protection@mercedes-benz.com
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
